import { curry } from './fp';

export let sum = curry(function sum (valueA, valueB) {
	return valueA + valueB;
});


//////////////////
// WEBPACK FOOTER
// ./src/utils/math.js
// module id = null
// module chunks = 